import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import { useMediaUrlWithState } from "hhn-commons";
import { IMessageDataVideo } from "@home-health-notify/domain";
import TextContentWrapper from "../../../common/TextContentWrapper";
import {
  VideoContentClickable,
  VideoContentContainer,
  VideoContentOverlay,
  VideoContentWrapper,
  VideoIcon,
} from "./VideoContent.style";
import MessageImageThumbnail from "./MessageImageThumbnail";
import ExpandableText from "../../../common/ExpandableText";

type Props = {
  videoMessage: IMessageDataVideo;
  isPendingMessage: boolean;
  onOpenPreview: () => void;
};

const VideoContentItem = ({
  videoMessage,
  isPendingMessage,
  onOpenPreview,
}: Props) => {
  const thumbState = useMediaUrlWithState(
    isPendingMessage ? "" : videoMessage.thumbnail,
  );
  const isErrored = thumbState.error;

  return (
    <VideoContentWrapper>
      <VideoContentClickable
        onClick={() => {
          if (isErrored) return;
          onOpenPreview();
        }}
      >
        <VideoContentContainer>
          {!isErrored && (
            <VideoContentOverlay>
              <VideoIcon color="inherit" />
              <PlayCircleFilledWhiteOutlinedIcon
                color="inherit"
                fontSize="large"
              />
            </VideoContentOverlay>
          )}
          <MessageImageThumbnail
            url={videoMessage.thumbnail}
            text={videoMessage.text}
            isPendingMessage={isPendingMessage}
            isVideoThumbnail={true}
          />
        </VideoContentContainer>
      </VideoContentClickable>
      {videoMessage.text && (
        <TextContentWrapper>
          <ExpandableText>{videoMessage.text}</ExpandableText>
        </TextContentWrapper>
      )}
    </VideoContentWrapper>
  );
};

export default VideoContentItem;
